module.exports = __webpack_public_path__ + "img/nabl_detail.dec52577.jpg";